module.exports = __webpack_public_path__ + "img/16_10.85e8860c.png";